import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=70ef9d45&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ef9d45')) {
      api.createRecord('70ef9d45', component.options)
    } else {
      api.reload('70ef9d45', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=70ef9d45&", function () {
      api.rerender('70ef9d45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23ho07D2vrbu6/JS/pricehelp.vue"
export default component.exports